export const MailingOptions = {
  title: 'title',
  full: 'full'
};
